"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecord = isRecord;
function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
